import '@ionic/core';
import { Component, Event, EventEmitter, h, Prop, State, Watch } from '@stencil/core';

import { retrieveSelectorData } from '../../utils/tools';

@Component({
    tag: 'selector-region-type',
    styleUrl: 'selector-region-type.css',
    shadow: true
})

export class RegionTypeSelector {
    @Prop() cohortId = 0;
    @Prop() regionSelections: Array<string>;

    @Watch('regionSelections') 
    watchHandler(newValue: Array<string>) {
        // console.log(`Updated types property in selector-area-type component, newValue: ${newValue}, oldValue: ${oldValue}`);
        // this.regionSelections = newValue;
        this.selectedCount = newValue.length;
    }

    @Event() regionsSelectionCompleted: EventEmitter;

    @State() selectedCount: number;
    @State() regionsLoaded: boolean = false;

    @Event() regionSelectionCompleted: EventEmitter;

    private baseURL: string = 'https://api.probono.savvysuit.com/v2/cohort/'; 
    private regionTypeList: Array<any> = [];
    private firstRun: boolean = true;

    private updateRegionsSelected = (e: any) => {
        try {
            this.selectedCount = e.detail.value.length;
        } catch (error) {
            this.selectedCount = 0;
        }

        let newRegionSelections = [];

        try {
            e.detail.value.forEach(region => {
                newRegionSelections.push({ value: region, resolution: 'county' });
            });
        } catch (e) {
            console.error(`Error processing region selections: ${e}`);
        }
        
        this.regionSelectionCompleted.emit(newRegionSelections);
    }

    private processTypes = (cohortId, rawTypes: Array<any>) => {
        if(rawTypes.length > 0) {
            const formattedRegionList = [];

            rawTypes.forEach(region => {
                formattedRegionList.push({
                    value: region.toLowerCase(),
                    label: region,
                    disabled: false
                });
            });

            this.regionsLoaded = true;

            this.regionTypeList = formattedRegionList;
        }

        console.log(`Updated list of Regions for cohort ${cohortId}.`);

        this.render();
    }

    private loadRegionTypes = async (baseURL: string, cohortId: number) => {
        console.log('Requesting list of current region types');

        let response: any = {};

        try {
            response = await retrieveSelectorData(baseURL.concat(`${cohortId}/regions`))

            console.log(`Successfully retrieved cohort-specific Area data for cohort: ${cohortId}`)
        } catch (fetchError) {
            console.error(`FAILURE loading Region type data.`)

            response.data = { data: [] };  
        }

        let regionData: any;

        try {
            regionData = response.data
        } catch (parseError) {
            console.error('FAILURE parsing Region type data');

            regionData = [];
        }

        this.processTypes(cohortId, regionData);
    }

    componentWillLoad() {
        if(this.firstRun) {
            try {
                this.selectedCount = this.regionSelections.length;
            } catch (error) {
                this.selectedCount = 0;
            }
    
            this.firstRun = false;
        }

        const styleBodyText = ".SSPBRegionTypeSelectorAlert { --max-width: unset !important; --width: 60% !important; } .alert-checkbox-button-disabled .alert-checkbox-icon { display: none; } .alert-checkbox-button-disabled .alert-checkbox-label { padding-left: 25px; }";
        const alertStyleText = document.createTextNode(styleBodyText);
        const alertStyle: any = document.createElement('style');

        alertStyle.type = 'text/css';
        alertStyle.appendChild(alertStyleText)

        document.getElementsByTagName("head")[0].appendChild(alertStyle);

        this.loadRegionTypes(this.baseURL, this.cohortId);
    }

    selectClicked() {
        /* const alertElement = document.querySelector('ion-alert.SSPBRegionTypeSelectorAlert');
        alertElement.setAttribute("style", "position: fixed; height: 100vh;");
        console.log('Updated ion-alert position for region-type select'); */
        return;
    }

    render() {
        return ( 
            <div id="RegionTypeSelectorStage">
                <ion-item>
                    <ion-select label="Regions" onIonBlur={this.selectClicked}
                      interfaceOptions={{cssClass: 'SSPBRegionTypeSelectorAlert'}} id="SSPBRegionTypeSelector"
                      value={this.regionSelections} multiple={true} onIonChange={this.updateRegionsSelected}
                      selectedText={`${this.selectedCount} selected`}>
                        {this.regionTypeList.map( type => {
                            return (
                                <ion-select-option value={type.value} disabled={type.disabled}>{type.label}</ion-select-option>
                            );
                        })}
                    </ion-select>
                </ion-item>
            </div>
        );
    }
}
